// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueElementLoading from 'vue-element-loading'
import store from './store/store'
import VModal from 'vue-js-modal'
import 'jquery/dist/jquery.min.js'
import Datepicker from 'vuejs-datepicker'
import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
import VueHtmlToPaper from 'vue-html-to-paper'
import VueSimplePrintPlugin from 'vue-simple-print'
import VueGeolocation from 'vue-browser-geolocation'
import VueBarcodeScanner from 'vue-barcode-scanner'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false
Vue.use(VueBarcodeScanner)
Vue.use(VueGeolocation)
// CommonJS
// const Swal = require('sweetalert2')
Vue.use(VueSimplePrintPlugin)
Vue.use(VueTabs)
Vue.use(VModal)
Vue.component('VueElementLoading', VueElementLoading)
Vue.prototype.$apiURL = 'https://plfilters.com/api/api/'
// Vue.prototype.$apiURL = ' http://127.0.0.1:8000/api/'
// Vue.prototype.$apiURL = 'https://plfilters.com/api/api/'
Vue.prototype.$treasuries = {}
Vue.prototype.$technicals = {}
Vue.prototype.$delegates = {}
Vue.prototype.$stores = {}
Vue.prototype.$per = {} // permissions
Vue.prototype.$isSysAdmin = false // me :)
Vue.use(VueHtmlToPaper)

Vue.prototype.$Customer = {branche_id: 0}
// Vue.prototype.$openReg = {id: '994966'}
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  Datepicker,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js